import PropTypes from "prop-types";

export default {
	title: PropTypes.string,
	minText: PropTypes.string,
	maxText: PropTypes.string,
};
